const Ziggy = {
  url: import.meta.env.VITE_APP_URL,
  port: null,
  defaults: {},
  routes: {
    "debugbar.openhandler": { uri: "_debugbar/open", methods: ["GET", "HEAD"] },
    "debugbar.clockwork": { uri: "_debugbar/clockwork/{id}", methods: ["GET", "HEAD"], parameters: ["id"] },
    "debugbar.assets.css": { uri: "_debugbar/assets/stylesheets", methods: ["GET", "HEAD"] },
    "debugbar.assets.js": { uri: "_debugbar/assets/javascript", methods: ["GET", "HEAD"] },
    "debugbar.cache.delete": { uri: "_debugbar/cache/{key}/{tags?}", methods: ["DELETE"], parameters: ["key", "tags"] },
    "debugbar.queries.explain": { uri: "_debugbar/queries/explain", methods: ["POST"] },
    handleOndatoWebhook: { uri: "api/v1/ondato-hooks", methods: ["POST"] },
    "users.index": { uri: "api/users", methods: ["GET", "HEAD"] },
    testGet: { uri: "test/get", methods: ["GET", "HEAD"] },
    testMail: { uri: "test/mail", methods: ["GET", "HEAD"] },
    testPost: { uri: "test/post", methods: ["POST"] },
    contactUsMail: { uri: "contact-us/mail", methods: ["POST"] },
    signUpAccount: { uri: "sign-up/account", methods: ["POST"] },
    validateFields: { uri: "sign-up/validate", methods: ["POST"] },
    resendEmail: { uri: "sign-up/resend-email", methods: ["POST"] },
    checkHashLink: { uri: "link/check-hash", methods: ["POST"] },
    login: { uri: "auth/login", methods: ["POST"] },
    resetPassword: { uri: "auth/reset-password", methods: ["POST"] },
    updatePassword: { uri: "auth/update-password", methods: ["POST"] },
    updateEmail: { uri: "auth/update-email", methods: ["POST"] },
    generateMailChangeEmail: { uri: "auth/send-update-email", methods: ["POST"] },
    resendEmailChangeEmail: { uri: "auth/resend-update-email", methods: ["POST"] },
    logOut: { uri: "auth/logOut", methods: ["POST"] },
    authUser: { uri: "auth/user", methods: ["GET", "HEAD"] },
    getUserDetails: { uri: "user-details", methods: ["GET", "HEAD"] },
    createOrUpdateUserDetails: { uri: "user-details/create-or-update", methods: ["POST"] },
    getCountries: { uri: "user-details/countries", methods: ["GET", "HEAD"] },
    uploadImages: { uri: "files/upload", methods: ["POST"] },
    removeImage: { uri: "files/remove", methods: ["POST"] },
    createUser: { uri: "user/create", methods: ["POST"] },
    updateUser: { uri: "user/update", methods: ["POST"] },
    getUserFiles: { uri: "user/files", methods: ["GET", "HEAD"] },
    getSavedProfiles: { uri: "user/save-profiles", methods: ["GET", "HEAD"] },
    getUserCollabInterest: { uri: "user/collab-interest", methods: ["GET", "HEAD"] },
    getUserContentInterest: { uri: "user/content-interest", methods: ["GET", "HEAD"] },
    syncUserCollabInterest: { uri: "user/sync-collab-interest", methods: ["POST"] },
    syncUserContentInterest: { uri: "user/sync-content-interest", methods: ["POST"] },
    deleteAccount: { uri: "user/delete-account", methods: ["POST"] },
    updateMyPassword: { uri: "user/update-my-password", methods: ["POST"] },
    getCategories: { uri: "categories", methods: ["GET", "HEAD"] },
    getPinnedUsers: { uri: "categories/pined-users", methods: ["GET", "HEAD"] },
    createCategory: { uri: "categories/create", methods: ["POST"] },
    updateCategory: { uri: "categories/update", methods: ["POST"] },
    pinUsers: { uri: "categories/pin-users", methods: ["POST"] },
    getUserCategoryValues: { uri: "user-categories-values", methods: ["GET", "HEAD"] },
    updateOrCreateCategoryHasValues: { uri: "user-categories-values/update-or-create", methods: ["POST"] },
    getLink: { uri: "ondato", methods: ["GET", "HEAD"] },
    getUsersStat: { uri: "admin-dashboard/users-stat", methods: ["GET", "HEAD"] },
    getUsers: { uri: "admin-dashboard/users", methods: ["GET", "HEAD"] },
    getCollabRequest: { uri: "admin-dashboard/collab-request", methods: ["GET", "HEAD"] },
    approveUser: { uri: "admin-dashboard/approved-user", methods: ["POST"] },
    declineUser: { uri: "admin-dashboard/decline-user", methods: ["POST"] },
    requestEdit: { uri: "admin-dashboard/request-edit", methods: ["POST"] },
    getUserList: { uri: "homepage/users", methods: ["GET", "HEAD"] },
    getUnverifiedAccounts: { uri: "homepage/unverified-users", methods: ["GET", "HEAD"] },
    showCollabRequest: { uri: "collab-request", methods: ["POST"] },
    createCollabRequest: { uri: "collab-request/create", methods: ["POST"] },
    approvedCollabRequest: { uri: "collab-request/approved", methods: ["POST"] },
    declineCollabRequest: { uri: "collab-request/decline", methods: ["POST"] },
    cancelCollabRequest: { uri: "collab-request/cancel", methods: ["POST"] },
    getUserPreference: { uri: "user-preference", methods: ["GET", "HEAD"] },
    updateOrCreateUserPreference: { uri: "user-preference/update-or-create", methods: ["POST"] },
    getUserNotifications: { uri: "user-notifications", methods: ["GET", "HEAD"] },
    getUserCollabAcceptedNotifications: { uri: "user-notifications/collab-accepted", methods: ["GET", "HEAD"] },
    getUserNotificationsCount: { uri: "user-notifications/count", methods: ["GET", "HEAD"] },
    markNotificationAsRead: { uri: "user-notifications/marked-as-read", methods: ["POST"] },
    markAllNotificationAsRead: { uri: "user-notifications/marked-all-as-read", methods: ["POST"] },
    getSettings: { uri: "system-settings", methods: ["GET", "HEAD"] },
    updateOrCreateSettings: { uri: "system-settings/update-or-create", methods: ["POST"] },
    getAllAcceptedCollabRequest: { uri: "chat/admin-chatlist", methods: ["GET", "HEAD"] },
    getChatList: { uri: "chat/user-chatlist", methods: ["GET", "HEAD"] },
    getMessages: { uri: "chat/messages/{receiverId}", methods: ["GET", "HEAD"], parameters: ["receiverId"] },
    markMessagesAsRead: { uri: "chat/marked-message-as-read", methods: ["POST"] },
    sendMessage: { uri: "chat/send", methods: ["POST"] },
    getBroadcastMessages: { uri: "broadcast-messages/get-broadcast-messages", methods: ["GET", "HEAD"] },
    createBroadcastMessage: { uri: "broadcast-messages/create", methods: ["POST"] },
    getBroadcastMessageRecipients: {
      uri: "broadcast-message-recipient/get-broadcast-message-recipient",
      methods: ["GET", "HEAD"],
    },
    generateSitemap: { uri: "seo/generate-sitemap", methods: ["GET", "HEAD"] },
    sendReferralContactUsEmail: { uri: "referral/contact-us", methods: ["POST"] },
    reportedUsers: { uri: "users/reported-users", methods: ["GET", "HEAD"] },
    reportUser: { uri: "users/report-user", methods: ["POST"] },
    banReportedUser: { uri: "users/reported-users/{reportedUserId}/ban", methods: ["POST"], parameters: ["reportedUserId"] },
    dismissReportedUser: {
      uri: "users/reported-users/{reportedUserId}/dismiss",
      methods: ["POST"],
      parameters: ["reportedUserId"],
    },
    messageReportedUser: {
      uri: "users/reported-users/{reportedUserId}/message",
      methods: ["POST"],
      parameters: ["reportedUserId"],
    },
    suspendUser: { uri: "suspensions", methods: ["POST"] },
    liftSuspension: { uri: "suspensions/{user}", methods: ["DELETE"], parameters: ["user"], bindings: { user: "id" } },
    showSuspension: {
      uri: "suspensions/{suspension}",
      methods: ["GET", "HEAD"],
      parameters: ["suspension"],
      bindings: { suspension: "id" },
    },
    "storage.local": { uri: "storage/{path}", methods: ["GET", "HEAD"], wheres: { path: ".*" }, parameters: ["path"] },
  },
};
if (typeof window !== "undefined" && typeof window.Ziggy !== "undefined") {
  Object.assign(Ziggy.routes, window.Ziggy.routes);
}
export { Ziggy };
